import React from "react";
import {CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import {Button} from "@components/Input";
import {successSvg} from "assets";
import "./mailbox_creation_dialog.scss";

export default function MailboxCreationDialog({creation, open, onClose, onCheck, t}) {
    if (!creation) return null;
    const key = "integrations:channels.centridesk.emails.creation";
    return (
        <Dialog className="centridesk-mailbox-dialog" open={open} onClose={onClose} fullWidth maxWidth="sm"
                aria-labelledby="mailbox-creation-title" aria-describedby="mailbox-creation-description">
            <DialogTitle id="mailbox-creation-title">{t(`${key}.${creation.phase}.title`)}</DialogTitle>
            <DialogContent>
                <div className="mailbox-creation-copy" role="status" aria-live="polite" aria-atomic="true">
                    {["pending", "waiting", "deleting", "checking"].includes(creation.phase) && <CircularProgress size={24} aria-hidden="true"/>}
                    {creation.phase === "success" && (
                        <span className="mailbox-creation-success-icon" aria-hidden="true">{successSvg()}</span>
                    )}
                    <p style={{overflowWrap: "anywhere"}}>{creation.senderEmail}</p>
                    {creation.operation && <p style={{overflowWrap: "anywhere"}}>{t(`${key}.reference`)}: {creation.operation.id}</p>}
                    {creation.errorCode && <p role="alert">{t(`integrations:channels.centridesk.emails.errors.${creation.errorCode}`, t("integrations:channels.centridesk.emails.errors.default"))}</p>}
                    <p id="mailbox-creation-description">{t(`${key}.${creation.phase}.description`)}</p>
                </div>
            </DialogContent>
            <DialogActions>
                <Button type={creation.phase === "success" ? "success" : "secondary"}
                        text={t(`${key}.close`)} onClick={onClose}/>
                {creation.phase === "unconfirmed" &&
                    <Button type="primary" text={t(`${key}.check`)} onClick={onCheck}/>}
            </DialogActions>
        </Dialog>
    );
}
